<template>
    <v-card class="pa-1 d-flex justify-space-between file-info" outlined>
        <v-icon>insert_drive_file</v-icon>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <div class="subtitle-2 file-name" v-on="on">
                    {{ id ? file.name.substring(file.name.indexOf('_') + 1) : file.name }}
                </div>
            </template>
            <span>{{ id ? file.name.substring(file.name.indexOf('_') + 1) : file.name }}</span>
        </v-tooltip>
        <v-menu offset-y>
            <template v-slot:activator="{ on }">
                <v-icon v-on="on">keyboard_arrow_down</v-icon>
            </template>
            <v-list>
                <v-list-item  v-if="isEmployee" @click="removeFile()">
                    <v-list-item-title>{{ $t('common.fileInfo.delete') }}</v-list-item-title>
                </v-list-item>
                <v-list-item text :href="file.url" :download="file.name.indexOf('_') + 1" v-if="file.url">
                    <v-list-item-title>{{ $t('common.fileInfo.download') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-card>
</template>

<script>

import API from '@/api'

export default {
    name: 'file-info',
    props: ['file', 'id', 'type', 'clearFile'],
    data () {
        return {}
    },
    computed: {
        isEmployee: function () {
            return this.$helpers.checkIsEmployee()
        }
    },
    methods: {
        async removeFile () {
            if (confirm(`${this.$t('common.fileInfo.confirm')} ${this.file.name}`)) {
                if (!this.id) {
                    this.clearFile(this.file.name)
                } else {
                    const params = {
                        objectId: this.id,
                        type: this.type
                    }

                    let endpoint = API.EndPoints.removeDemandFile
                    await new API(endpoint, params).request().then(response => {
                        alert(this.$t('common.fileInfo.success'))
                        if (this.type === 'interaction') {
                            this.clearFile()
                        } else {
                            this.clearFile(this.file.name)
                        }
                    }, (e) => {
                        this.$helpers.requestError(e)
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss">
.file-info {
    .file-name {
        max-height: 1.375rem;
        overflow: hidden;
    }
}
.file-info:hover{
    background-color: #f6f8f9;
}
</style>
